import React, { useEffect, useState } from "react";
import Index from "../../../../container/Index";

import PagesIndex from "../../../PagesIndex";

import moment from "moment";

import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

import { useSelector } from "react-redux";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import { OutlinedInput } from "@mui/material";
import {
  billDelete,
  billStatus,
  generateOtpCommitte,
  getBillList,
  verifyOtpCommitte,
} from "../../../../redux/features/AddService";
import { toast } from "react-toastify";
import {
  validationSchemaApproveAmoumt,
  validationSchemaVerifyCommitteOTP,
} from "../../../../validation/Validation";
import OTPInput from "react-otp-input";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#eaac35",
    color: "#ffffff",
    fontSize: "11px",
    fontFamily: "Poppins-Regular",
    padding: "5px 9px",
    lineHeight: "19px",
    borderRadius: "10px",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 100,
    },
  },
};

const BillList = () => {
  let deleteText = "bill";
  const location = PagesIndex.useLocation();
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const { getAdminLoginDetails } = PagesIndex.useSelector(
    (state) => state.admin
  );
  const [searchedData, setSearchedData] = React.useState([]);
  const [pageData, setPageData] = useState([]);
  const [rowPerPage, setRowPerPage] = useState("25");
  const [statusFilter, setStatusFilter] = useState("Pending");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  const [amountOpen, setAmountOpen] = React.useState(false);
  const [otpOpen, setOtpOpen] = useState(false);

  const [billId, setBillId] = useState("");
  const [showClaimedAmount, setShowClaimedAmount] = useState("");

  const [loader, setLoader] = useState(true);

  const [applicationListData, setApplicationListData] = useState([]);
  const [approvedAmonut, setApprovedAmonut] = React.useState();

  const handleCloseApproved = () => {
    setAmountOpen(false);
  };

  const handleOpenOtp = () => {
    setAmountOpen(false);
    setOtpOpen(true);
  };
  const handleCloseOtp = () => {
    setOtpOpen(false);
  };

  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();

  const { state } = PagesIndex.useLocation();

  const RowIdHighlightData = state?.rowID;

  const handleDeleteOpen = (data) => {
    setDeleteId(data?.Id);

    setDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
    setDeleteId("");
  };

  //#region start function for otp modal

  const handleOpenApproved = (id, claimedAmount, approvedAmountData) => {
    setBillId(id);
    setShowClaimedAmount(claimedAmount);
    setApprovedAmonut(approvedAmountData);
    setAmountOpen(true);
  };

  const handleGenerateOtp = (values) => {
    setApprovedAmonut(values?.approvedAmount);
    dispatch(generateOtpCommitte()).then((res) => {
      if (res?.payload?.status == 200) {
        toast.success(res?.payload?.message);
        handleOpenOtp();
      }
    });
  };

  const handleVerifyOtp = (values) => {
    dispatch(verifyOtpCommitte(values)).then((res) => {
      if (res?.payload?.status == 200) {
        handleApproveReject(billId, "Approved", approvedAmonut);
        handleCloseOtp();
      }
    });
  };
  const getPrograms = () => {
    dispatch(getBillList()).then((data) => {
      if (data?.payload) {
        setLoader(false);
        const filterData = data?.payload?.filter((ele) => {
          if (rollData === "staff" || rollData === "committee") {
            return ele?.billStatus == statusFilter;
          }
          return true;
        }) ?.filter((ele) => {
              if (rollData === "committee") {
                return (
                  getAdminLoginDetails?.sahayPermission &&
                  getAdminLoginDetails?.sahayPermission.includes(
                    ele?.ProgramData?.[0]?.SahayName
                  )
                );
              }
              return true;
            })
        setApplicationListData(filterData);
      }
      setLoader(false);
    });
  };

  const handleDeleteRecord = () => {
    let data = {
      id: deleteId,
    };

    dispatch(billDelete(data)).then((res) => {
      if (res?.payload == 200) {
        getPrograms();
      }
    });
    setDeleteOpen(false);
  };

  const handleApproveReject = (id, status, amount) => {
    let data = {
      BillId: id,
      status: status,
      approveBillAmount: amount ? amount : "",
    };

    dispatch(billStatus(data)).then((res) => {
      if (res?.payload == 200) {
        getPrograms();
      }
    });
  };

  useEffect(() => {
    getPrograms();
  }, [statusFilter]);

  useEffect(() => {
    setSearchedData(applicationListData);
  }, [applicationListData]);

  const requestSearch = (searched) => {
    if (!searched) return setSearchedData(applicationListData);
    setSearchedData(
      applicationListData.filter(
        (item) =>
          item?.vendorName?.toString().includes(searched?.toLowerCase()) ||
          item?.billNumber
            ?.toString()
            .toLowerCase()
            .includes(searched.toLowerCase()) ||
          item?.totalAmount
            ?.toString()
            .toLowerCase()
            .includes(searched.toLowerCase()) ||
          item?.ProgramData?.[0]?.programName
            ?.toString()
            .toLowerCase()
            .includes(searched.toLowerCase()) ||
          item?.billStatus
            ?.toString()
            ?.toLowerCase()
            ?.includes(searched?.toLowerCase())
      )
    );
  };

  const { rollPermissionData } = useSelector((state) => state.admin);

  //Edit Sahay application
  const handleEdit = (data) => {
    data["lastStatus"] = statusFilter;
    navigate(`/${rollData}/add-edit-bill`, {
      state: { editBill: data },
    });
  };

  const handleView = (data) => {
    data["lastStatus"] = statusFilter;
    navigate(`/${rollData}/view-bill`, {
      state: { viewBillData: data },
    });
  };

  //#region Active Status
  useState(() => {
    if (location?.state?.prevState) {
      setStatusFilter(location?.state?.prevState);
    }
  }, [location?.state?.prevState]);

  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box className="title-header">
                <Index.Box className="title-header-flex res-title-header-flex">
                  <Index.Box className="plus-hidden-show-mobile">
                    <Index.Box className="title-main">
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="page-title"
                      >
                        Bills
                      </Index.Typography>
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="d-flex align-items-center res-set-search">
                    <PagesIndex.Search
                      className="search"
                      onChange={(e) => {
                        requestSearch(e.target.value);
                      }}
                    >
                      <PagesIndex.StyledInputBase
                        placeholder="Search"
                        inputProps={{ "aria-label": "search" }}
                      />
                    </PagesIndex.Search>

                    {["committee", "staff"]?.includes(
                      rollData?.toLowerCase()
                    ) ? (
                      <Index.Box className="lable-input-grp pending-button-sahay">
                        <Index.FormControl
                          sx={{ width: "100%" }}
                          className="main-select"
                        >
                          <Index.Select
                            className="select-drop"
                            displayEmpty
                            value={statusFilter}
                            onChange={(e) => {
                              setStatusFilter(e.target.value);
                            }}
                            input={<OutlinedInput />}
                            MenuProps={MenuProps}
                            inputProps={{
                              "aria-label": "Without label",
                            }}
                          >
                            <Index.MenuItem value={"Pending"}>
                              Pending
                            </Index.MenuItem>
                            <Index.MenuItem value={"Approved"}>
                              Approved
                            </Index.MenuItem>
                            <Index.MenuItem value={"Rejected"}>
                              Rejected
                            </Index.MenuItem>
                          </Index.Select>
                        </Index.FormControl>
                      </Index.Box>
                    ) : null}

                    <>
                      {rollData == "staff" && (
                        <Index.Box className="common-button blue-button res-blue-button desk-hidden-show ">
                          <PagesIndex.Link
                            to={`/${rollData}/add-edit-bill`}
                            className="no-text-decoration"
                          >
                            <Index.Button
                              variant="contained"
                              disableRipple
                              className="apply-sahay-btn"
                            >
                              <Index.ControlPointIcon /> <span>Add Bill</span>
                            </Index.Button>
                          </PagesIndex.Link>
                        </Index.Box>
                      )}
                    </>
                  </Index.Box>
                </Index.Box>
              </Index.Box>

              <Index.Box className="">
                <Index.TableContainer
                  sx={{ maxHeight: 480 }}
                  // component={Index.Paper}
                  className="table-container sahay-application-container scroll-table common-table-container-custom"
                >
                  <Index.Table
                    stickyHeader
                    aria-label="sticky table"
                    className="table-design-main barge-table sahay-appli-table"
                  >
                    <Index.TableHead className="sahay-appli-head">
                      <Index.TableRow className="sahay-appli-tr">
                        <Index.TableCell className="sahay-appli-tr">
                          Vendor Name
                        </Index.TableCell>

                        <Index.TableCell className="sahay-appli-tr">
                          Bill Number
                        </Index.TableCell>
                        <Index.TableCell
                          className="user-sahay-td"
                          style={{ cursor: "pointer" }}
                        >
                          Bill Date
                        </Index.TableCell>
                        <Index.TableCell
                          className="sahay-appli-tr"
                          align="left"
                        >
                          Total Amount
                        </Index.TableCell>
                        <Index.TableCell
                          className="sahay-appli-tr"
                          align="left"
                        >
                          Approved Amount
                        </Index.TableCell>
                        <Index.TableCell
                          className="sahay-appli-tr"
                          align="left"
                        >
                          Program Name
                        </Index.TableCell>
                        <Index.TableCell
                          className="sahay-appli-tr"
                          align="left"
                        >
                          Disbursement status
                        </Index.TableCell>

                        <Index.TableCell
                          className="sahay-appli-tr"
                          align="left"
                        >
                          Bill Status
                        </Index.TableCell>

                        <Index.TableCell
                          className="sahay-appli-tr"
                          align="left"
                        >
                          Action
                        </Index.TableCell>
                      </Index.TableRow>
                    </Index.TableHead>
                    <Index.TableBody>
                      {pageData?.length ? (
                        pageData?.map((row, index) => (
                          <Index.TableRow
                            key={row?.Id}
                            className={`sahay-appli-tr ${
                              row?.Id === RowIdHighlightData
                                ? "highlighted-row"
                                : ""
                            }`}
                          >
                            <Index.TableCell
                              align="left"
                              className="sahay-appli-td"
                            >
                              {row?.vendorName || "-"}
                            </Index.TableCell>

                            <Index.TableCell
                              align="left"
                              className="sahay-appli-td"
                            >
                              {row?.billNumber || "-"}
                            </Index.TableCell>
                            <Index.TableCell
                              align="left"
                              className="sahay-appli-td"
                            >
                              {moment(row?.billDate).format("DD/MM/YYYY")}
                            </Index.TableCell>

                            <Index.TableCell
                              align="left"
                              className="sahay-appli-td"
                            >
                              {row?.totalAmount}
                            </Index.TableCell>

                            <Index.TableCell
                              align="left"
                              className="sahay-appli-td"
                            >
                              {row?.approveBillAmount || "-"}
                            </Index.TableCell>
                            <Index.TableCell
                              align="left"
                              className="sahay-appli-td"
                            >
                              {row?.ProgramData?.[0]?.programName}
                            </Index.TableCell>
                            <Index.TableCell
                              align="left"
                              className="sahay-appli-td"
                            >
                              {row?.billDisbursedStatus == null
                                ? "Pending"
                                : row?.billDisbursedStatus}
                            </Index.TableCell>

                            <Index.TableCell
                              align="left"
                              className="sahay-appli-td"
                            >
                              <Index.Box
                                className={`status-details ${
                                  row?.billStatus == "Pending"
                                    ? "pending - status"
                                    : row?.billStatus == "Approved"
                                    ? "approved-status"
                                    : row?.billStatus == "Rejected"
                                    ? "reject-status"
                                    : ""
                                }`}
                              >
                                {row?.billStatus}
                              </Index.Box>
                            </Index.TableCell>

                            <Index.TableCell
                              sx={{ display: "flex" }}
                              className="sahay-appli-td"
                            >
                              <Index.Box className="flex-content-sahay">
                                {row?.billStatus?.toLowerCase() == "pending" &&
                                rollData == "staff" ? (
                                  <>
                                    <LightTooltip title="Edit">
                                      <Index.IconButton
                                        onClick={() => handleEdit(row)}
                                      >
                                        <Index.EditIcon className="muiico-edit" />
                                      </Index.IconButton>
                                    </LightTooltip>
                                  </>
                                ) : null}
                                <LightTooltip title="View">
                                  <Index.IconButton
                                    onClick={() => handleView(row)}
                                  >
                                    <Index.Visibility className="muiico-view" />
                                  </Index.IconButton>
                                </LightTooltip>

                                {row?.billStatus?.toLowerCase() == "pending" &&
                                rollData == "staff" ? (
                                  <>
                                    <LightTooltip title="Delete">
                                      <Index.IconButton
                                        onClick={() => handleDeleteOpen(row)}
                                      >
                                        <Index.DeleteIcon className="muiico-delete" />
                                      </Index.IconButton>
                                    </LightTooltip>
                                  </>
                                ) : null}

                                {rollData === "committee" &&
                                  row?.billDisbursedStatus == null && (
                                    <LightTooltip title="Approve">
                                      <Index.Box className="approved-btn">
                                        <Index.Button
                                          className="approve-btn-list"
                                          onClick={() =>
                                            handleOpenApproved(
                                              row?.Id,
                                              row?.totalAmount,
                                              row?.approveBillAmount
                                            )
                                          }
                                          disabled={
                                            row?.committeApproval &&
                                            Array.isArray(
                                              JSON.parse(row?.committeApproval)
                                            ) &&
                                            JSON.parse(
                                              row?.committeApproval
                                            ).some(
                                              (committee) =>
                                                committee?.committeeName ===
                                                  getAdminLoginDetails?.name &&
                                                committee?.committeeNumber ===
                                                  getAdminLoginDetails?.mobileno
                                            )
                                          }
                                        >
                                          <img
                                            src={PagesIndex.Svg.approve}
                                            alt="Approve"
                                            className="approve"
                                          />
                                        </Index.Button>
                                      </Index.Box>
                                    </LightTooltip>
                                  )}

                                {rollData == "committee" &&
                                  row?.billDisbursedStatus == null && (
                                    <LightTooltip title="Reject">
                                      <Index.Box className="reject-btn">
                                        <Index.Button
                                          className="reject-btn-list"
                                          onClick={() =>
                                            handleApproveReject(
                                              row?.Id,
                                              "Rejected"
                                            )
                                          }
                                          disabled={
                                            row?.committeApproval &&
                                            Array.isArray(
                                              JSON.parse(row?.committeApproval)
                                            ) &&
                                            JSON.parse(
                                              row?.committeApproval
                                            ).some(
                                              (committee) =>
                                                committee?.committeeName ===
                                                  getAdminLoginDetails?.name &&
                                                committee?.committeeNumber ===
                                                  getAdminLoginDetails?.mobileno
                                            )
                                          }
                                        >
                                          <img
                                            src={PagesIndex.Svg.incorrect}
                                            className="reject"
                                          ></img>
                                        </Index.Button>
                                      </Index.Box>
                                    </LightTooltip>
                                  )}
                              </Index.Box>
                            </Index.TableCell>
                          </Index.TableRow>
                        ))
                      ) : (
                        <PagesIndex.NoRecordFound colSpan={12} />
                      )}
                    </Index.TableBody>
                  </Index.Table>
                </Index.TableContainer>
              </Index.Box>

              <Index.Box className="pagination-design flex-end">
                <RowPerPageDropdown
                  rowPerPage={rowPerPage}
                  setRowPerPage={setRowPerPage}
                />
                <Index.Stack spacing={2}>
                  <PagesIndex.Pagination
                    fetchData={searchedData}
                    setPageData={setPageData}
                    pageData={pageData}
                    rowPerPage={rowPerPage}
                  />
                </Index.Stack>
              </Index.Box>
            </Index.Box>
          </Index.Box>
          <PagesIndex.DeleteModal
            deleteText={deleteText}
            deleteOpen={deleteOpen}
            handleDeleteRecord={handleDeleteRecord}
            handleDeleteClose={handleDeleteClose}
          />
        </>
      )}
      {/* ////////////////////// This is for claimed and approved amount ///////////////// */}
      <Index.Modal
        open={amountOpen}
        onClose={handleCloseApproved}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-delete modal"
      >
        <Index.Box
          sx={style}
          className="delete-modal-inner-main modal-inner approve-amount-model"
        >
          <PagesIndex.Formik
            enableReinitialize
            onSubmit={handleGenerateOtp}
            validationSchema={validationSchemaApproveAmoumt}
            initialValues={{
              claimedAmount: showClaimedAmount,
              approvedAmount: approvedAmonut ? approvedAmonut : "",
            }}
          >
            {({
              values,
              handleChange,
              handleSubmit,
              touched,
              setFieldValue,
              handleBlur,
              errors,
              isValid,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <Index.Box className="remark-textarea-details">
                  <Index.Box className="set-text-area ">
                    <Index.Box sx={{ flexGrow: 1 }} className="al-form-groups">
                      <Index.Grid container spacing={2}>
                        <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                          <Index.Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "end",
                            }}
                          >
                            <Index.IconButton onClick={handleCloseApproved}>
                              <Index.CloseIcon />
                            </Index.IconButton>
                          </Index.Box>
                        </Index.Grid>
                        <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                          <Index.Box className="lable-input-grp">
                            <Index.Typography
                              component="p"
                              className="in-label"
                            >
                              Claimed Amount (દાવો કરેલ રકમ)
                            </Index.Typography>
                            <Index.TextField
                              type="number"
                              disabled
                              placeholder="Enter claimed amount"
                              className="basic-input input-width"
                              name="claimedAmount"
                              value={values?.claimedAmount}
                              onChange={(event) => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 10) {
                                  // Only update the value if it's not more than 30 characters
                                  handleChange(event);
                                }
                              }}
                              onBlur={handleBlur}
                            />
                          </Index.Box>
                        </Index.Grid>
                        <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                          <Index.Box className="lable-input-grp">
                            <Index.Typography
                              component="p"
                              className="in-label"
                            >
                              Approved Amount(મંજૂર રકમ)
                            </Index.Typography>
                            <Index.TextField
                              type="number"
                              placeholder="Enter approved amount"
                              // inputProps={ariaLabel}
                              className="basic-input input-width"
                              name="approvedAmount"
                              value={values?.approvedAmount}
                              onChange={(event) => {
                                const inputValue = event.target.value;
                                if (
                                  Number(inputValue) <=
                                  Number(values?.claimedAmount)
                                ) {
                                  handleChange(event);
                                }
                              }}
                              onBlur={handleBlur}
                            />
                          </Index.Box>
                          {errors?.approvedAmount &&
                            touched?.approvedAmount && (
                              <p
                                className="error-text"
                                style={{ marginTop: "10px" }}
                              >
                                {errors?.approvedAmount}
                              </p>
                            )}
                        </Index.Grid>
                      </Index.Grid>
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="btn-submit-area">
                    <Index.Box className="common-button blue-button change-password-btn update_priofile_btn">
                      <Index.Button
                        variant="contained"
                        disableRipple
                        type="submit"
                      >
                        Submit
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </form>
            )}
          </PagesIndex.Formik>
        </Index.Box>
      </Index.Modal>

      {/* //#region for otp apporve modal /////////////// */}

      <Index.Modal
        open={otpOpen}
        onClose={handleCloseOtp}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-delete modal"
      >
        <Index.Box
          sx={style}
          className="delete-modal-inner-main modal-inner approve-amount-model"
        >
          <PagesIndex.Formik
            enableReinitialize
            onSubmit={handleVerifyOtp}
            validationSchema={validationSchemaVerifyCommitteOTP}
            initialValues={{
              OTP: "",
            }}
          >
            {({
              values,
              handleChange,
              handleSubmit,
              touched,
              setFieldValue,
              handleBlur,
              errors,
              isValid,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <Index.Box className="remark-textarea-details">
                  <Index.Box className="set-text-area ">
                    <Index.Box sx={{ flexGrow: 1 }} className="al-form-groups">
                      <Index.Grid container spacing={2}>
                        <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                          <Index.Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "end",
                            }}
                          >
                            <Index.IconButton onClick={handleCloseOtp}>
                              <Index.CloseIcon />
                            </Index.IconButton>
                          </Index.Box>
                        </Index.Grid>

                        <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                          <Index.Box className="lable-input-grp">
                            <Index.Box className="box-login-text bluebox-text text-center">
                              <Index.Typography
                                variant="body1"
                                component="p"
                                className=""
                              >
                                Please Enter Otp.
                              </Index.Typography>
                            </Index.Box>
                            <OTPInput
                              name="otp"
                              numInputs={4}
                              inputStyle="otp-verification-input"
                              containerStyle="otp-verification-input-wrap"
                              inputType="number"
                              value={values.OTP}
                              onChange={(file) => setFieldValue("OTP", +file)}
                              // error={Boolean(errors.otp)}
                              renderInput={(props) => <input {...props} />}
                            />
                            {errors?.OTP && touched?.OTP && (
                              <p
                                className="error-text"
                                style={{ marginTop: "10px" }}
                              >
                                {errors?.OTP}
                              </p>
                            )}
                          </Index.Box>
                        </Index.Grid>
                      </Index.Grid>
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="btn-submit-area">
                    <Index.Box className="common-button blue-button change-password-btn update_priofile_btn">
                      <Index.Button
                        variant="contained"
                        disableRipple
                        type="submit"
                      >
                        Submit
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </form>
            )}
          </PagesIndex.Formik>
        </Index.Box>
      </Index.Modal>
    </>
  );
};

export default BillList;
